__turbopack_context__.v({
  "icon": "index-module-scss-module__dEoQDq__icon",
});
